import { render } from "./Leads-form.vue?vue&type=template&id=aa09b89a&scoped=true"
import script from "./Leads-form.vue?vue&type=script&lang=js"
export * from "./Leads-form.vue?vue&type=script&lang=js"

import "./Leads-form.vue?vue&type=style&index=0&id=aa09b89a&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.25_vue@3.5.25_typescript@5.4.2__webpack@5.103.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa09b89a"]])

export default __exports__